module.exports = __webpack_public_path__ + "img/49.8ec8c4ce.jpg";